module.exports = __webpack_public_path__ + "images/shop/favicon-kfz24/android-chrome-512x512.png";